import React from 'react'
import GenericTable from '../general/generic-table'
import { utilService } from '../../services/util-service'

interface EntitySystemTableProps {
    data: any[]
    onEditClick?: (entitySystem: any) => void
}

const createMapping = (title: string, location: string[], type: string, trueText?: string, falseText?: string) => ({
    title, location, type, trueText, falseText
})

const mapping = [
    createMapping('ID', ['id'], 'int'),
    createMapping('Entity Name', ['entity', 'name'], 'string'),
    createMapping('System Name', ['system', 'name'], 'string'),
    createMapping('Integration Type', ['integrationType'], 'string'),
    createMapping('Is Required Daily', ['isRequiredDaily'], 'boolean', 'Yes', 'No'),
    createMapping('Is Generate IPE', ['isGenerateIpe'], 'boolean', 'Yes', 'No'),
    createMapping('Force Generate', ['forceGenerate'], 'json'),
]

const IconPencil = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
)

export const EntitySystemTable: React.FC<EntitySystemTableProps> = ({ data, onEditClick }) => {
    const tableData: any[][] = data.map((record: any) =>
        mapping.map((m) => ({
            title: m.title,
            value: utilService.getCellValue(record, m),
            type: m.type,
        }))
    )

    const handleEditClick = onEditClick ? (rowData: any[]) => {
        const idCell = rowData.find((cell: any) => cell.title === 'ID')
        const esId = Number(idCell?.value)
        const rawItem = data.find((item: any) => Number(item.id) === esId)
        if (rawItem) onEditClick(rawItem)
    } : undefined

    return (
        <GenericTable
            data={tableData}
            recordName="Entity Systems"
            hiddenByDefault={['ID']}
            onEditClick={handleEditClick}
            editColumn="Entity Name"
            filterableColumns={['Entity Name', 'System Name', 'Integration Type', 'Is Required Daily', 'Is Generate IPE', 'Force Generate']}
        />
    )
}
